import React from "react";

import ProgressBar from "../common/ProgressBar";
import styles from "../../styles/pages/product/ProductDetailsPage.module.css";

const ProductMatchInsights = ({
  matchData,
  iconsMap,
  getDimensionBarClass,
  aiSessionRank = null,
  dimensionsOnly = false,
}) => {
  if (!matchData || matchData.percentage == null) return null;

  const dimensionsToShow = matchData.dimensions || [];
  if (!dimensionsToShow.length) return null;

  const dimensionList = (
    <div className={styles.dimensionList}>
      {dimensionsToShow.map((dimension, idx) => {
        const IconComponent =
          iconsMap[dimension.icon] || iconsMap.FaCheckCircle;
        const displayScore = Math.round(
          Math.min(100, Math.max(0, dimension.score)),
        );

        return (
          <div key={idx} className={styles.dimensionItem}>
            <div className={styles.dimensionHeader}>
              <div className={styles.dimensionName}>
                {IconComponent && (
                  <IconComponent className={styles.dimensionIcon} />
                )}
                <span>{dimension.name}</span>
              </div>
              <span className={styles.dimensionScore}>{displayScore}%</span>
            </div>
            <div className={styles.dimensionBar}>
              <ProgressBar
                className={`${styles.dimensionBarFill} ${getDimensionBarClass(
                  displayScore,
                )}`}
                percentage={displayScore}
              />
            </div>
            <p className={styles.dimensionReason}>{dimension.reason}</p>
          </div>
        );
      })}
    </div>
  );

  if (dimensionsOnly) {
    return (
      <div className={styles.whyFitsSection}>
        <h4 className={styles.dimensionTitle}>Detailed Match Breakdown</h4>
        {dimensionList}
      </div>
    );
  }

  return (
    <div className={styles.whyFitsSection}>
      <h3 className={styles.whyFitsTitle}>Why This Fits You</h3>
      {aiSessionRank != null && (
        <p className={styles.aiSessionRankBadge}>
          In your AI matches (#{aiSessionRank})
        </p>
      )}
      {matchData.dealBreakerFailed && (
        <p className={styles.dimensionReason}>
          This product is missing a must-have feature from your profile.
        </p>
      )}
      <div className={styles.matchPercentage}>
        <div className={styles.percentageCircle}>
          <span className={styles.percentageValue}>{matchData.percentage}%</span>
          <span className={styles.percentageLabel}>Match</span>
        </div>
        <div className={styles.matchReasons}>
          {(matchData.reasons || []).map((reason, idx) => (
            <div key={idx} className={styles.reasonBullet}>
              <span className={styles.bullet}>✓</span>
              <span>{reason}</span>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.dimensionScores}>
        <h4 className={styles.dimensionTitle}>Detailed Match Breakdown</h4>
        {dimensionList}
      </div>
    </div>
  );
};

export default ProductMatchInsights;
